import React, { useEffect, useState } from "react";
import { GetAccount } from "../../services/clientService";
import { TextField, Typography, Box } from "@mui/material";
export default function AccountSearch({
	value,
	className,
	onChange,
	isValidated,
	onAccountData, // ✅ New prop
  }) {
	const [acc, setAcc] = useState(null);
	const [isValidAccount, setIsValidAccount] = useState(true);
  
	useEffect(() => {
	  if (value === "") {
		setAcc(null);
		isValidated(false);
		setIsValidAccount(true);
		onAccountData?.(null); // clear it in parent
		return;
	  }
  
	  const timeoutId = setTimeout(async () => {
		try {
		  let account = await GetAccount(value);
		  setAcc(account);
		  isValidated(true);
		  setIsValidAccount(true);
		  onAccountData?.(account); // ✅ send full account object or just type
		} catch (err) {
		  setAcc(null);
		  isValidated(false);
		  setIsValidAccount(false);
		  onAccountData?.(null); // indicate invalid
		}
	  }, 500);
  
	  return () => clearTimeout(timeoutId);
	}, [value]);
  
	return (
	  <Box>
		<TextField
		  fullWidth
		  variant="outlined"
		  label="Account Number"
		  value={value}
		  onChange={onChange}
		  placeholder="Enter account number"
		  className={className}
		  size="small"
		  error={!isValidAccount}
		  helperText={!isValidAccount ? "Invalid account number" : ""}
		/>
		{acc && (
		  <Typography
			variant="subtitle2"
			color="success.main"
			fontWeight="bold"
			mt={1}
		  >
			{acc.clientName}
		  </Typography>
		)}
	  </Box>
	);
  }
  